export default __webpack_public_path__ + "static/media/GiftIcon.65eb996b.svg";